export default "__VITE_ASSET__CgoXa4g4__"